// HeaderContext.js
import { createContext, useContext, useState } from "react";

const HeaderContext = createContext();

export const HeaderProvider = ({ children }) => {
  const [headerNumber, setHeaderNumber] = useState(null);
  const [listCountHeader, setListCountHeader] = useState(null);

  return (
    <HeaderContext.Provider
      value={{
        headerNumber,
        setHeaderNumber,
        listCountHeader,
        setListCountHeader,
      }}
    >
      {children}
    </HeaderContext.Provider>
  );
};

export const useHeader = () => useContext(HeaderContext);
